import React, { useState } from "react";
import "./Counter.css";

export default function Counter() {
    const [count, setCount] = useState(0);

    return (
        <div className="counter">
            <h2>Count: {count}</h2>
            <button onClick={() => setCount(count + 1)}>Increment</button>
            <button onClick={() => setCount(count - 1)}>Decrement</button>
        </div>
    );

}